export enum SocContactsActions {
  EDIT = "editSocContacts",
  REMOVE = "removeSocContacts",
  CREATE = "createSocContacts",
}

export enum SocRemediationActions {
  CHANGE_REMEDIATION_TYPE = "changeSocRemediationType",
}
